var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-filter',{staticClass:"trash-filter",attrs:{"leftName":_vm.leftName,"rightName":_vm.$t('file.trash.filter'),"arrowUp":_vm.showActionSheet},on:{"filter-click":_vm.onFilterClick}})}
var staticRenderFns = []

export { render, staticRenderFns }